import { clone } from '@jkhy/frontend-utils/functions';
import {
    BannerAndModalMessageModelDto,
    DashboardInformationCenterModelDto,
} from '@treasury/api/channel';
import { DomainEntity } from '../shared';

const emptyBannerAndModalMessage: BannerAndModalMessageModelDto = {
    title: '',
    description: '',
    type: '',
};

// Used to differentiate between BannerAndModalMessageModelDto and DashboardInformationCenterModelDto
// They are identical except DashboardInformationCenterModelDto has a 'sequence' property
export function isBannerAndModalMessage(
    message: BannerAndModalMessageModelDto | DashboardInformationCenterModelDto
): message is BannerAndModalMessageModelDto {
    return (message as DashboardInformationCenterModelDto).sequence === undefined;
}

export class BannerAndModalMessage extends DomainEntity<BannerAndModalMessageModelDto> {
    constructor(dto = clone(emptyBannerAndModalMessage)) {
        super(dto);
    }

    public createDefault(): this {
        return new BannerAndModalMessage(clone(emptyBannerAndModalMessage)) as this;
    }

    public get title() {
        return this.dto.title;
    }

    public get description() {
        return this.dto.description;
    }

    public get type() {
        return this.dto.type;
    }
}
